import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import styles from './index.module.less';
import { NavLink } from 'react-router-dom';
export const NavTabs = ({ className, tabs, ...rest }) => {
    if (tabs.length === 0)
        return null;
    return (_jsx("ul", { className: classnames(className, styles.tabList), ...rest, children: tabs.map((tab) => (_jsx("li", { className: styles.tabItem, children: _jsx(NavLink, { className: styles.tab, activeClassName: styles.selected, to: tab.to, children: tab.label }) }, tab.key))) }));
};
